export default function CTAAppel() {
  return (
    <section className="bg-brand-blue py-12 md:py-16">
      <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
        <h2 className="text-white text-2xl md:text-3xl font-extrabold mb-4">
          Besoin d'un devis pour motoriser vos volets ?
        </h2>
        <p className="text-white/80 text-base md:text-lg mb-8 max-w-2xl mx-auto">
          Nos techniciens interviennent à Strasbourg et dans le Bas-Rhin pour la pose de motorisation Somfy. Devis gratuit, réponse sous 24h.
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3 justify-center">
          <a
            href="tel:0374473240"
            className="inline-flex items-center justify-center gap-2 bg-brand-cyan text-white px-6 py-4 rounded-full font-semibold text-base hover:bg-brand-cyan/90 transition-all duration-200 btn-hover-effect whitespace-nowrap"
          >
            <span className="btn-icon-wrap"><i className="ri-phone-line text-lg"></i></span>
            Appeler le 03 74 47 32 40
          </a>
          <a
            href="#devis"
            className="inline-flex items-center justify-center gap-2 bg-white text-brand-blue px-6 py-4 rounded-full font-semibold text-base hover:bg-white/90 transition-all duration-200 btn-hover-effect whitespace-nowrap"
          >
            Devis gratuit
          </a>
        </div>
      </div>
    </section>
  );
}